/**
 * /house → the live Claude House (09-24). Reddit posts, the house nights
 * calendar and anything printed say myspaice.ai/house, so none of them bakes a
 * house id: when the house moves, HOUSE_SPACE_PATH moves and every old link
 * follows. Extra query params ride along (Reddit's utm tags, a ?room= deep
 * link); a gameId in the incoming link never overrides the house.
 */
import { HOUSE_SPACE_PATH } from '../data/whatsNew';

export function houseRedirectTarget(search) {
  const [path, query = ''] = HOUSE_SPACE_PATH.split('?');
  const params = new URLSearchParams(query);
  for (const [key, value] of new URLSearchParams(search || '')) {
    if (key.toLowerCase() !== 'gameid') params.append(key, value);
  }
  return `${path}?${params.toString()}`;
}
